import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import Container from "../components/ui/Container/Container";
import { QueryKey } from "../services/query-keys";
import IOrganization from "../shared/IOrganization";
import ErrorsAlert from "../components/ErrorsAlert/ErrorsAlert";
import { ErrorResponse } from "../custom-fetch";
import Spinner from "../components/ui/Spinner/Spinner";
import OrganizationEdit from "../components/Organizations/OrganizationEdit";
import { useOrganizationsService } from "../services/organizations-service";
import PageHeading from "../components/ui/PageHeading/PageHeading";
import { Route } from "../routes";

type Params = {
  id: string;
};

const OrganizationPage: React.FC = () => {
  const { id } = useParams<Params>();
  const { getOrganization } = useOrganizationsService();
  
  const {
    data: organization,
    isLoading,
    isError,
    error,
  } = useQuery<IOrganization, ErrorResponse>({
    queryKey: [QueryKey.organizations, id],
    queryFn: ({ signal }) => getOrganization({ signal, id: id! }),
    enabled: id !== 'add',
  });

  return (
    <>
      <PageHeading backTo={Route.organizations}>{id === 'add' ? 'Add Organization' : 'Edit Organization'}</PageHeading>
      <Container>
        {isError && error ? (
          <ErrorsAlert errors={error.messages} />
        ) : isLoading && id !== 'add' ? (
          <Spinner />
        ) : (
          <OrganizationEdit id={id!} organization={organization} />
        )}
      </Container>
    </>
  );
};

export default OrganizationPage;
